import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'CERCA TRA GLI ESERCIZI ZANICHELLI',
        description:
            'Trovi gli esercizi delle Idee per insegnare dei tuoi libri. Scrivi nel campo di ricerca: ti saranno suggeriti tutti gli argomenti che hanno esercizi associati. Raffina la tua ricerca con gli altri filtri.',
        name: 'EditorialExercisesSearchForm',
        tutorialName: 'crea-verifica_tab-Zanichelli'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'right',
        xPlacement: 'RIGHT',
        yPlacement: 'MIDDLE',
        xOffset: -5,
        yOffset: 3
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'LEFT',
        yPlacement: 'MIDDLE',
        xOffset: 10,
        yOffset: 0
    }
};
